import { setTheme } from "store/theme/theme.action";
import { selectTheme } from "store/theme/theme.selector";
import { THEME_KEY } from "utils/helper/states";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { checkUserSession, signOutStart } from "store/user/user.action";
import { onSessionExpired } from "services/session-events";
import { fetchData } from "store/data/data.actions";
import { fetchDisplayServices } from "store/service/service.actions";
import { selectCurrentUser } from "store/user/user.selector";
import { websocketService } from "services/websocketService";

export const alertMessage = (type: string, msg: string) => {
  const themeStore = localStorage.getItem(THEME_KEY);
  const theme =
    themeStore != null
      ? themeStore
      : window.matchMedia("(prefers-color-scheme: dark)")
      ? "dark"
      : "light";
  const toastC =
    type === "error"
      ? toast.error
      : type === "info"
      ? toast.info
      : type === "success"
      ? toast.success
      : type === "warn"
      ? toast.warn
      : toast;
  toastC(msg, {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: theme,
  });
};

const InitialState = () => {
  const dispatch = useDispatch();
  const theme = useSelector(selectTheme),
  user = useSelector(selectCurrentUser);

  useEffect(() => {
    const localTheme = localStorage.getItem(THEME_KEY);
    if (
      localTheme == null &&
      window.matchMedia("(prefers-color-scheme: dark)").matches
    ) {
      dispatch(setTheme("dark"));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    // console.log(theme);
    if (theme === "dark") {
      document.querySelector("html")?.classList.add("dark");
      document.documentElement.setAttribute("data-theme", "dark");
    } else {
      document.querySelector("html")?.classList.remove("dark");
      document.documentElement.setAttribute("data-theme", "light");
    }
  }, [theme, dispatch]);

  useEffect(() => {
    dispatch(fetchData());
    dispatch(fetchDisplayServices());
    dispatch(checkUserSession());
  }, [dispatch]);

  useEffect(() => {
    // Any 401 (HTTP or socket) ends the session through one path (W02).
    onSessionExpired(() => {
      alertMessage("warn", "Your session has expired. Please sign in again.");
      dispatch(signOutStart());
    });
    return () => onSessionExpired(null);
  }, [dispatch]);

  const token = user?.token;
  useEffect(() => {
    // One socket per signed-in session, closed on sign-out (W03).
    if (token) {
      websocketService.connect(token);
      return () => websocketService.disconnect();
    }
    websocketService.disconnect();
    return undefined;
  }, [token]);

  return <></>;
};

export default InitialState;
